import React from 'react';

const LoadingSpinnerIcon: React.FC<React.SVGProps<SVGSVGElement>> = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="7.5" width="2" height="5" rx="1" fill="white" />
      <rect
        opacity="0.7"
        x="0.5"
        y="7"
        width="5"
        height="2"
        rx="1"
        fill="white"
      />
      <rect
        opacity="0.1"
        x="11.5"
        y="7"
        width="5"
        height="2"
        rx="1"
        fill="white"
      />
      <rect
        opacity="0.4"
        x="7.5"
        y="11"
        width="2"
        height="5"
        rx="1"
        fill="white"
      />
      <rect
        opacity="0.25"
        x="10.5"
        y="11.4142"
        width="2"
        height="5"
        rx="1"
        transform="rotate(-45 10.5 11.4142)"
        fill="white"
      />
      <rect
        opacity="0.85"
        x="1.5"
        y="2.41422"
        width="2"
        height="5"
        rx="1"
        transform="rotate(-45 1.5 2.41422)"
        fill="white"
      />
      <rect
        opacity="0.01"
        x="14.0356"
        y="1"
        width="2"
        height="5"
        rx="1"
        transform="rotate(45 14.0356 1)"
        fill="white"
      />
      <rect
        opacity="0.55"
        x="5.03564"
        y="10"
        width="2"
        height="5"
        rx="1"
        transform="rotate(45 5.03564 10)"
        fill="white"
      />
    </svg>
  );
};

export default LoadingSpinnerIcon;
